module.exports = __webpack_public_path__ + "img/header.eee7a6dc.svg";